import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

export function TermsPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Link to="/" className={styles.backLink}>← Back to Home</Link>
        
        <h1 className={styles.title}>Terms of Service</h1>
        <p className={styles.lastUpdated}>Last updated: January 1, 2026</p>

        <section className={styles.section}>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Omen SEO service operated by OmenSystems, 
            you agree to be bound by these Terms of Service. If you do not agree to these 
            terms, do not use our service.
          </p>
        </section>

        <section className={styles.section}>
          <h2>2. Description of Service</h2>
          <p>
            Omen SEO provides automated website SEO, security, performance, and 
            compliance assessments. Our service scans publicly accessible websites and 
            generates risk reports based on industry standards and best practices.
          </p>
        </section>

        <section className={styles.section}>
          <h2>3. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account 
            credentials and for all activities that occur under your account. You must 
            provide accurate and complete information when creating an account.
          </p>
        </section>

        <section className={styles.section}>
          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Scan websites you do not own or have authorization to scan</li>
            <li>Use the service for any unlawful purpose</li>
            <li>Attempt to circumvent rate limits or access controls</li>
            <li>Resell or redistribute scan results without permission</li>
            <li>Interfere with the proper functioning of the service</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>5. Subscriptions and Payments</h2>
          <p>
            Paid subscriptions are billed monthly. You may cancel at any time, and access 
            will continue until the end of your current billing period. Refunds are 
            provided at our discretion.
          </p>
        </section>

        <section className={styles.section}>
          <h2>6. Disclaimer of Warranties</h2>
          <p>
            The service is provided "as is" without warranties of any kind. We do not 
            guarantee that our scans will detect all security vulnerabilities or compliance 
            issues. Our reports are for informational purposes and should not be considered 
            professional security advice.
          </p>
        </section>

        <section className={styles.section}>
          <h2>7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, OmenSystems shall not be liable for 
            any indirect, incidental, special, consequential, or punitive damages arising 
            from your use of the service.
          </p>
        </section>

        <section className={styles.section}>
          <h2>8. Changes to Terms</h2>
          <p>
            We may modify these terms at any time. Continued use of the service after 
            changes constitutes acceptance of the modified terms.
          </p>
        </section>

        <section className={styles.section}>
          <h2>9. Governing Law</h2>
          <p>
            These terms shall be governed by and construed in accordance with applicable 
            laws, without regard to conflict of law principles.
          </p>
        </section>

        <section className={styles.section}>
          <h2>10. Contact</h2>
          <p>
            For questions about these terms, contact us at{' '}
            <a href="mailto:legal@omensystems.com">legal@omensystems.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
